<template>
    <el-dialog
            class="expenience-tranfer-dialog"
            top="15vh"
            width="340px"
            :close-on-press-escape="false"
            :close-on-click-modal='false'
            :visible="dialogShow"
            :before-close="beforeCloseHandle"
    >
        <section class="box">
            <p class="title fs20 font333 blod center">{{$t('Apply_to_transfer_out')}}</p>
            <div class="line-box">
                <span class="left-box">{{$t('User.totalBalance')}}</span>
                <span class="right-ele">${{total}}</span>
            </div>
            <div class="line-box">
                <span class="left-box">{{$t('profit')}}</span>
                <span class="right-ele">${{profit}}</span>
            </div>
            <div class="line-box">
                <span class="left-box">{{$t('withgold.RollOutAmount')}}</span>
                <span class="right-ele">${{finalMoney}}</span>
            </div>
            <el-form
                    :model="form"
            >
                <el-form-item class="select-type-item">
                    <el-select
                            class="select-type"
                            v-model="form.type"
                    >
                        <el-option
                                v-for="(item,index) in typeList"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    v-if="form.type == 1"
                    prop="bankAccount"
                >
                    <div class="line-box">
                        <span class="left-box">{{$t('Bank_card_number')}}</span>
                        <span class="right-ele">{{form.bankAccount}}</span>
                    </div>
                </el-form-item>
                <el-form-item
                        v-else
                        prop="login"
                >
                    <el-select
                            class="select-type"
                            v-model="form.login"
                    >
                        <el-option
                                v-for="(item,index) in loginList"
                                :key="index"
                                :label="item.login"
                                :value="item.login"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="btns-outer center">
                <el-button
                        size="small"
                        class="candle-btn"
                        @click="cancleHandle"
                >{{$t('root.cancle')}}</el-button>
                <el-button
                        size="small"
                        class="submit-btn"
                        type="primary"
                        @click="saveAdd"
                        :loading="saveLoading"
                >{{$t('User.save')}}</el-button>
            </div>
        </section>
    </el-dialog>
</template>

<script>
    import { mapGetters } from 'vuex'
  import { getBankInfo, mtAccList } from '@/api/userCenter.js';
    import { queryrecordInfo } from '@/api/user'
  export default {
    name: 'expenienceTranferDialog',
    props: {
      dialogShow: {
        type: Boolean,
        default: false,
      },
      rowData:{
        type: Object,
      }
    },
    data() {
      return {
        form:{
          type: 1,
          login: '',
          bankAccount: '',
        },
        loginList:[],
        profit: '',
        total: '',
        maxGiveMoney: '',
        saveLoading: false,
      };
    },
    created(){
      this.getBank();
      if(this.userInfo.id){
        this.getMt4List();
      }
    },
    computed: {
        ...mapGetters(['userInfo',]),
      typeList(){
          return [
            {
              value: 1,
              label: this.$t('Transfer_out_to_bank_card'),
            },
            {
              value: 2,
              label: this.$t('Transfer_to_MT4'),
            }
          ];
      },
      finalMoney(){
          return this.profit > this.maxGiveMoney ? this.maxGiveMoney: this.profit;
      }
    },
    watch:{
      rowData: {
        handler(newValue, oldValue) {
          if(newValue.id){
            this.getRecordInfo(newValue.id);
          }
        },
        deep: true,
      }
    },
    methods: {
      close(){
        this.$emit('close');
      },
      beforeCloseHandle(){
        this.close();
      },
      cancleHandle(){
        this.close();
      },
      saveAdd(){
        if(this.form.type == 1){
          if(!this.form.bankAccount){
            this.$message({
              type: 'warning',
              message: this.$t('experienceNoCardTips')
            });
            return;
          }
        }
        if(this.form.type == 2){
          if(!this.form.login){
            this.$message({
              type: 'warning',
              message: this.$t('experienceNoMt4Tips')
            });
            return;
          }
        }
        this.$emit('roll-out',{type: this.form.type, targetLogin: this.form.login});
      },
      getRecordInfo(id){
        queryrecordInfo({id: id}).then((res) => {
          this.total = res.data[0].balance;
          this.profit = res.data[0].profit;
          this.maxGiveMoney = res.data[0].maxGiveMoney;
        })
      },
      getBank() {
        getBankInfo({
          custId: this.userInfo.id,
          type: 1,
        }).then((res) => {
          this.form.bankAccount = res.data[0].bankAccount;
        })
      },
      getMt4List(){
        mtAccList({
          id : this.userInfo.id,
          businessTypes: '0,1,2,3',
        }).then((res) => {
            this.loginList = res.data;
            this.form.login = this.loginList[0].login;
        })
      }
    }
  };
</script>
<style lang="scss">
    .expenience-tranfer-dialog {
        .el-dialog__body {
            padding-top: 10px;
            padding-left: 30px;
            padding-right: 30px;
        }
    }
</style>
<style lang="scss" scoped>
.box {
    .title {
        margin-bottom: 40px;
    }
    .line-box {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #333333;
        border-bottom: 1px solid #E6E6E6;
    }
    /deep/ .select-type {
        width: 100%;
        .el-input__inner {
            border-left: none;
            border-right: none;
            border-top: none;
            border-radius: 0;
            padding-left: 0;
            padding-right: 0;
            border-color: #E6E6E6;
        }
        .el-input__suffix {
            right: 0;
        }
    }
    /deep/ .select-type-item {
        margin-bottom: 0;
    }
}
</style>
